import { useState } from "react";
import axios from 'axios';
import { showMessage } from "react-native-flash-message";
import { baseUrl } from "../API/restUrl";
import { useAuthContext } from "./useAuthContext";
import { useUserRole } from "../context/userroleContext";
import AsyncStorage from '@react-native-async-storage/async-storage';
import packageJson from '../../package.json';
import { useTranslation } from 'react-i18next';

const FRONTEND_VERSION = packageJson.version;

export const useSignin = () => {
  const [isLoading, setIsLoading] = useState(null);
  const { t } = useTranslation();
  const [versionMismatch, setVersionMismatch] = useState(null);
  const { dispatch } = useAuthContext();
  const { setUser, loadPermissions } = useUserRole();

  const permissions = (response, username) => {
    const accessLevelObj = JSON.parse(response.data.accessLevel);

    setUser(username);

    loadPermissions({
      hr: JSON.parse(accessLevelObj.hr),
      ss: JSON.parse(accessLevelObj.ss),
      admin: JSON.parse(accessLevelObj.admin),
    });
  };

  //to check the funcionality of this and make the version fail, go to package.json and change the version
  const checkVersion = async (api) => {
    try {
      const response = await axios.get(`${api}api/OasisParam/CheckVersion`, {
        params: {
          frontendVersion: FRONTEND_VERSION,
        },
        headers: {
          accepts: 'application/json',
          'Content-Type': 'application/json',
        },
      });

      setVersionMismatch(null);
      return response.status === 200;
    } catch (error) {
      if (error.response && error.response.status === 426) {
        setVersionMismatch({
          // message: error.response.data?.message || "Version mismatch detected.",
          message: t("common:versionMismatch"),
          backendVersion: error.response.data?.backendVersion ?? "-",
          frontendVersion: error.response.data?.frontendVersion ?? "-",
          databaseVersion: error.response.data?.databaseVersion ?? "-",
        });
      } else {
        setVersionMismatch({
          message: t("common:versionCheckFailed"),

        });
      }

      return false;
    }
  };

  const singUp = async (username, password, email) => {
    setIsLoading(true);
    let FcmDeviceToken;

    AsyncStorage.getItem('fcm_token').then((token) => {
      FcmDeviceToken = token;

      axios
        .post(`${baseUrl}/api/client/registerClient`, JSON.stringify({ username, password, email }),
          {
            headers: {
              'accepts': 'application/json',
              'Content-Type': 'application/json',
            },
          })
        .then(response => {
          if (response.status === 200) {
            if (response.data.accessLevel == '')
              throw ("No Access Rights Please Contact System Administrator");

            setIsLoading(false);
            dispatch({ type: 'SIGNUP', payload: response.data, username: username });
            permissions(response, username);

            AsyncStorage.setItem(
              "client_api",
              JSON.stringify({
                clientApi: response.data.clientApi,
              }));

            AsyncStorage.setItem(
              "login_data",
              JSON.stringify({
                username: username,
                responseData: response.data,
              })
            );
          }
        })
        .catch(error => {
          if (error.response && error.response.status == '401') {
            showMessage({
              message: "Invalid credentials. Please try again.",
              type: "danger",
              duration: 3000,
            });
            setIsLoading(false);
          } else {
            console.error(error);
            setIsLoading(false);
          }
        });
    });
  };

  const signIn2FA = async (response, api) => {
    setIsLoading(true);

    const versionOk = await checkVersion(api);
    if (!versionOk) {
      setIsLoading(false);
      return;
    }

    let application = 'OasysMob';
    let username = response.account.username.split('@')[0];
    let FcmDeviceToken;

    AsyncStorage.getItem('fcm_token').then((token) => {
      FcmDeviceToken = token;

      const user = {
        username: username,
        password: "",
        refreshExpiryDate: response.extExpiresOn,
        application: application,
        fcmDeviceToken: "",
        accessToken: response.accessToken,
      };

      axios
        .post(`${api}api/auth/authenticateAz`, JSON.stringify(user),
          {
            headers: {
              'Authorization': `Bearer ${response.accessToken}`,
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            },
          })
        .then(response => {
          if (response.status === 200) {
            if (response.data.accessLevel == '') {
              throw ("No Access Rights Please Contact System Administrator");
            }

            setIsLoading(false);
            dispatch({ type: 'LOGIN', payload: response.data, username: username, clientApi: api });
            permissions(response, username);

            AsyncStorage.setItem(
              "login_data",
              JSON.stringify({
                username: username,
                responseData: response.data,
              })
            );
          }
        })
        .catch(error => {
          console.log(error);
          if (error.response && error.response.status == '401') {
            showMessage({
              message: "Invalid credentials. Please try again.",
              type: "danger",
              duration: 3000,
            });
            setIsLoading(false);
          } else {
            if (error.response == undefined) {
              showMessage({
                message: error.message,
                type: "danger",
                duration: 3000,
              });
            }
            console.error(error);
            setIsLoading(false);
          }
        });
    });
  };

  const signin = async (username, password, api) => {
    setIsLoading(true);

    const versionOk = await checkVersion(api);
    if (!versionOk) {
      setIsLoading(false);
      return;
    }

    let application = 'OasysMob';
    let FcmDeviceToken;

    AsyncStorage.getItem('fcm_token').then((token) => {
      FcmDeviceToken = token;

      axios
        .post(`${api}api/auth/authenticate`, JSON.stringify({ username, password, application, FcmDeviceToken }),
          {
            headers: {
              'accepts': 'application/json',
              'Content-Type': 'application/json'
            },
          })
        .then(response => {
          if (response.status === 200) {
            if (response.data.accessLevel == '') {
              throw ("No Access Rights Please Contact System Administrator");
            }

            setIsLoading(false);
            dispatch({ type: 'LOGIN', payload: response.data, username: username, clientApi: api });
            permissions(response, username);

            AsyncStorage.setItem(
              "login_data",
              JSON.stringify({
                username: username,
                responseData: response.data,
              })
            );
          }
        })
        .catch(error => {
          console.log(error);
          if (error.response && error.response.status == '401') {
            showMessage({
              message: "Invalid credentials. Please try again.",
              type: "danger",
              duration: 3000,
            });
            setIsLoading(false);
          } else {
            if (error.response == undefined) {
              showMessage({
                message: error.message,
                type: "danger",
                duration: 3000,
              });
            }
            console.error(error);
            setIsLoading(false);
          }
        });
    });
  };

  const refreshSignIn = async (user, api) => {
    setIsLoading(true);

    try {
      const response = await axios.post(
        `${api}api/auth/refresh`,
        user,
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${user?.token ?? ''}`,
          },
        }
      );

      if (response.status === 200) {
        const raw = await AsyncStorage.getItem('login_data');
        const parsed = raw ? JSON.parse(raw) : null;
        const username = parsed?.username ?? null;

        dispatch({
          type: 'Refresh',
          payload: response.data,
          clientApi: api,
          username,
        });

        if (username) {
          permissions(response, username);
        }

        await AsyncStorage.setItem(
          'login_data',
          JSON.stringify({
            username,
            responseData: response.data,
          })
        );
      }

      return response;
    } catch (error) {
      console.log('Refresh Failed Logout:', error?.response?.status, error?.response?.data);
      dispatch({ type: 'LOGOUT' });
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    singUp,
    signin,
    signIn2FA,
    refreshSignIn,
    isLoading,
    versionMismatch,
    setVersionMismatch,
  };
};